import React, { memo, useEffect, useState } from 'react';
import './css/style.scss';

import { RiPlayCircleFill, CgArrowLongRight } from '../../../../components/icons';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/autoplay';
import SwiperCore, { EffectFade, Autoplay } from 'swiper';

// import ReactHtmlParser from 'react-html-parser';
import { reactHtmlParser } from '../../../../common/common';
import { log, specialityPopOver } from '../../../../common/common';
import ShareCard from '../../../ShareCard';
import LazyImage from '../../../CustomLibraries/LazyImage';
import useRedirect from '../../../customHooks/useRedirect';
import { medwiki_static_image } from '../../../../common/assets.common';
// install Swiper modules
SwiperCore.use([EffectFade, Autoplay]);

const ArchiveVideoCardV1 = (props) => {
  const cardData = props.medWikiListVideoCardDetails;
  const { redirectTo } = useRedirect();
  const [sponserLogo, setSponserLogo] = useState([]);
  const [isHoverd, setIsHoverd] = useState(false);
  const [activeHover, setActiveHover] = useState(false);
  const cardClick = () =>
    props.click ? props.click() : redirectTo('MedwikiDetails', cardData.type_id, cardData.question);
  useEffect(() => {
    if (cardData.sponsor_logo) {
      setSponserLogo(cardData?.sponsor_logo?.split(','));
    }
  }, []);

  return (
    <div className="w-100 float-start archCardV1Box shadow bg-white rounded-3 overflow-hidden pt-3 position-relative">
      <span
        className="graph-1 position-absolute start-0 bottom-0"
        style={{ backgroundColor: cardData?.color ?? '#ceb50a' }}
      ></span>
      <span
        className="graph-2 position-absolute start-0 bottom-0"
        style={{ backgroundColor: cardData?.color ?? '#ceb50a' }}
      ></span>
      <div className="crdV1topPart d-flex align-items-center justify-content-between position-relative py-1 px-3 ps-lg-4 mb-2">
        <span
          className="crdV1topPartGraph position-absolute h-100 start-0 top-50 translate-middle-y"
          style={{ backgroundColor: cardData?.color ?? '#ceb50a' }}
        ></span>
        <div className="text-black crdV1Speclty d-flex align-items-center gap-1">
          <span
            className={`fs-4 cursorPointer gtm_cl_archiveVideoCard_specialities`}
            // id={`archiveVideoCard_specialities_${cardData?.specialities_ids_and_names[0]?.id}`}
            onClick={() => {
              if (
                cardData?.specialities_ids_and_names &&
                cardData?.specialities_ids_and_names?.length > 0
              ) {
                redirectTo(
                  'Speciality',
                  cardData?.specialities_ids_and_names[0]?.id,
                  cardData?.specialities_ids_and_names[0]?.name
                );
              }
            }}
          >
            {cardData?.specialities && cardData?.specialities?.split(',')[0]}
          </span>
          {specialityPopOver(cardData?.specialities)}
        </div>
        <a href="javascript:void(0)" className="cardV1DotsMenu text-black">
          <ShareCard
            gtmTagVariable="gtm_cl_archiveVideoCard_share"
            data={{ title: cardData.question, url: cardData.deeplink }}
            // id={`${props.gtmTagVariable}_archiveVideoCard_share`}
          />
        </a>
      </div>
      {props.hideImage ? null : (
        <div
          className="w-100 float-start  archCardV1BoxPic cursorPointer position-relative overflow-hidden"
          onClick={cardClick}
        >
          <RiPlayCircleFill
            gtmTagVariable={`gtm_cl_archiveVideoCard`}
            customClass="text-white display-1 position-absolute top-50 start-50 translate-middle z-2"
          />

          <LazyImage
            src={cardData.image ? cardData?.image : medwiki_static_image}
            alt="banner"
            fallback_image={medwiki_static_image}
            className={`object-fit-cover h-100 w-100 float-start gtm_cl_archiveVideoCard`}
          />

          <div
            className={`overlay position-absolute top-0 start-0 bg-black bg-opacity-25 gtm_cl_archiveVideoCard`}
            onClick={cardClick}
          ></div>
        </div>
      )}
      <div className="w-100 float-start archCrdV1Btm p-3 pb-4 ps-0">
        <div className="w-100 d-flex text-start cardV1Topic ps-3 ps-lg-4 mb-2">
          {/* withChanel */}
          {/* <div className="rounded-circle cardV1ProfilePic overflow-hidden d-flex justify-content-center align-items-center border border-light">
            <img src="https://cdn5.vectorstock.com/i/1000x1000/75/49/minimalist-healthcare-or-medical-logo-design-image-vector-31927549.jpg" />
          </div> */}
          {/* withChanel */}

          <div className="cardV1TopicContent position-relative w-100" onClick={cardClick}>
            <p
              // href="javascript:void(0)"
              className={`text-black fs-16 fw-medium line-clamp-3 gtm_cl_archiveVideoCard`}
              // id={`archiveVideoCard_question_${cardData.type_id}`}
            >
              {reactHtmlParser(cardData.question)}
            </p>
            {/* <p className="text-dark fs-4">{cardData.date}</p> */}
          </div>
        </div>
        <div className="w-100 float-start cardV1Ftr d-flex align-items-center justify-content-between ps-3 ps-lg-4 mt-2">
          {/* sponser logo if single ================*/}
          {/* <div className="crdV1sponser">
            <div className="crdV1sponserIn">
              <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTjOsRDwZa6djQ2biIXGBJtOGHnLOB9AelrSA&usqp=CAU" />
            </div>
          </div> */}
          {/* sponser logo if single */}

          {sponserLogo.length == 1 && (
            <div className="crdV1sponser m-0 text-start">
              <div className="crdV1sponserIn w-100 bg-white position-relative">
                <LazyImage
                  src={sponserLogo[0]}
                  className="position-absolute start-0 top-50 translate-middle-y"
                  alt="sponsor logo"
                  logo
                />
              </div>
            </div>
          )}
          {sponserLogo.length == 0 && (
            <div className="crdV1sponser m-0 text-start">
              <div className="crdV1sponserIn w-100 bg-white position-relative"></div>
            </div>
          )}
          {/* sponser logo if multiple */}
          {sponserLogo.length > 1 && (
            <Swiper
              className="crdV1sponser m-0 text-start"
              navigation={false}
              spaceBetween={0}
              slidesPerView={1}
              loop={true}
              autoplay={{
                delay: 2500
              }}
              effect={'fade'}
            >
              {sponserLogo.map((logo, index) => {
                return (
                  <SwiperSlide
                    className="crdV1sponserIn w-100 bg-white position-relative"
                    key={index + 1}
                  >
                    <LazyImage
                      src={logo}
                      className="position-absolute start-0 top-50 translate-middle-y"
                      alt="sponsor logo"
                      logo
                    />
                  </SwiperSlide>
                );
              })}
            </Swiper>
          )}
          <div
            className="cardV1FtrBtn d-inline-block overflow-hidden py-3 px-4 fs-4 fw-medium rippleEffect rounded cursorPointer gtm_cl_archiveVideoCard"
            onClick={cardClick}
            onMouseEnter={() => {
              setIsHoverd(true);
              setActiveHover(true);
            }}
            onMouseLeave={() => {
              setIsHoverd(false);
              setActiveHover(false);
            }}
            style={{
              border: `${
                isHoverd && activeHover
                  ? '1px solid transparent'
                  : `1px solid ${cardData?.color ? cardData?.color : '#ceb50a'}`
              }`,
              backgroundColor: `${
                isHoverd && activeHover
                  ? cardData?.color
                    ? cardData?.color
                    : '#ceb50a'
                  : 'transparent'
              }`
            }}
          >
            {/* <div
              className="cardV1BtnHover position-absolute top-50 start-50 translate-middle gtm_cl_archiveVideoCard"
              style={{ backgroundColor: cardData?.color ?? '#ceb50a' }}
            ></div>
            <div
              className="cardV1BtnBorder rounded position-absolute start-0 top-50 translate-middle-y gtm_cl_archiveVideoCard"
              style={{ borderColor: cardData?.color ?? '#ceb50a' }}
            ></div> */}
            <span
              className="d-flex align-items-center gap-2"
              style={{
                color: `${isHoverd && activeHover ? '#fff' : cardData?.color ?? '#ceb50a'}`
              }}
            >
              View{' '}
              <CgArrowLongRight
                customClass="fs-4 ms-1"
                gtmTagVariable={`gtm_cl_archiveVideoCard`}
              />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
export default memo(ArchiveVideoCardV1);
